import * as actions from 'actions';

const INITIAL_STATE = {
  chat: {},
  interests: {},
  journal: {},
  goals: {}
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.FEED_RECEIVED: {
      const newState = {...state};

      action.result.feedItems
        .forEach(feedItem => {
          const { chat, interests, journal, goals } = feedItem;
          if (chat) { newState.chat[feedItem.chat.id] = feedItem.chat; }
          if (interests) { newState.interests[feedItem.interests.id] = feedItem.interests; }
          if (journal) { newState.journal[feedItem.journal.id] = feedItem.journal; }
          if (goals) {
            // for the actual goals inside - store only the ids here
            newState.goals[feedItem.goals.id] = {
              ...feedItem.goals,
              goals: feedItem.goals.goals.map(goal => goal.id)
            };
          }
        });

      return {
        ...state,
        ...newState
      };
    }

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/feed/widgets/reducer.js
 **/